// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1XcJW","buttons":"PendingPaymentAlert_buttons__Xsl2O"};